import tribunalAPI from "api/tribunalAPi";
import {
  BodyDocumentosDeActuacion, ParamsTodosDocumentosPDF,
  ResponseActuacionPDFService,
} from "interfaces/actuacionPDFservice/actuacionPDFServiceInterfaces";

const getObtenerDocumentosDeActuacionesBySystem = async (
  params: BodyDocumentosDeActuacion
) => {
  let url = "/actuaciones-pdf/obtener/actuaciones-by-sistema";
  return await tribunalAPI.get<ResponseActuacionPDFService>(url, {
    params,
  });
};

const getObtenerTodosDocumentosPDF = async (params: ParamsTodosDocumentosPDF) => {
  let url = "/actuaciones-pdf/obtener/getActuacionesPdfMerge";
  return await tribunalAPI.get(url, { params, responseType: "arraybuffer" });
}

const getObtenerTodosDocumentos = async (params: {}) => {
  let url = "/actuaciones-pdf/obtener/getActuacionesPdfMerge";
  return await tribunalAPI.get(url, { params, responseType: "arraybuffer" });
}

const getObtenerTodosDocumentosZIP = async (params: {}) => {
  let url = "/actuaciones-pdf/obtener/getActuacionesZipMerge";
  return await tribunalAPI.get(url, { params, responseType: "arraybuffer" });
}

export { getObtenerDocumentosDeActuacionesBySystem, getObtenerTodosDocumentosPDF, getObtenerTodosDocumentos, getObtenerTodosDocumentosZIP };
